import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzTooltip from '@@/library/v4/components/OzTooltip.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { offset, shift } from '@floating-ui/vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSharePanelCopyItemRow',
  props: {
    title: null,
    description: null,
    tooltipText: null,
    testId: null
  },
  emits: ['copy'],
  setup(__props: any, { emit }) {



const { dir } = storeToRefs(useSurfaceStore())

const descriptionRef = ref<InstanceType<typeof OzBaseButton> | null>(null)
const descriptionRefEl = computed(() => descriptionRef.value?.$el)
const xDescriptionTooltip = ref(false)
const isRtl = computed(() => dir.value === 'rtl')



const handleClickOnDescription = async (): Promise<void> => {
  xDescriptionTooltip.value = !xDescriptionTooltip.value
  emit('copy')
}

return { __sfc: true,dir, descriptionRef, descriptionRefEl, xDescriptionTooltip, isRtl, emit, handleClickOnDescription, __, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzTooltip, offset, shift, OzBaseButton }
}

})